import React, { useEffect, useState } from 'react'

const TransitionPreloadPage: React.FC= () => {
    const [ currentURL, setCurrentURL] = useState(window.location.pathname)

  useEffect(() => {
    document.title = 'redirecting...';

  }, []);

  return (
    <section id='redirecting'>
        <div className="arc"></div>
        <h1><span>LOADING</span></h1>
    </section>
  )
}

export default TransitionPreloadPage